import Configurations from '@/modules/common/common/models/APP/Configuration'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import schema from '@/modules/health/common/schemas/APP/HealthPymesConfigurationSchema'
import {
  CopaymentTypes,
  InsuranceTypes
} from '@/modules/health/rater/models/DXP/ConfigurationsProperties'
import HealthConfigurationTags from './HealthConfigurationTags'

import type TagAlertValue from '@/modules/core/models/TagAlertValue'
import { validate } from '@/utils/schemaValidatorUtils'
import { HealthMinMaxAges } from './HealthMinMaxAges'

export default class HealthPymesConfiguration extends Configurations<HealthMinMaxAges> {
  copaymentTypes!: CopaymentTypes
  insuranceTypes!: InsuranceTypes
  tags!: any
  startDateHint?: TagAlertValue | null
  defaultHiringMaxAges!: HealthMinMaxAges

  constructor(data?: HealthPymesConfiguration) {
    validate(schema, data)

    super(data)

    this.isPymes = true

    if (data?.copaymentTypes) {
      this.copaymentTypes = new CopaymentTypes(data.copaymentTypes)
    }

    if (data?.insuranceTypes) {
      this.insuranceTypes = new InsuranceTypes(data.insuranceTypes)
    }

    if (data?.tags) {
      this.tags = new HealthConfigurationTags(data.tags)
    }

    if (data?.hiringMaxAges) {
      this.hiringMaxAges = new HealthMinMaxAges(data.hiringMaxAges)
    }
    if (data?.defaultHiringMaxAges) {
      this.defaultHiringMaxAges = new HealthMinMaxAges(data.defaultHiringMaxAges)
    }
  }

  get copaymentTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.copaymentTypes)
  }
  get defaultCopaymentType(): string | null {
    return this.getDefaultValue(this.copaymentTypes)
  }

  get insuranceTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.insuranceTypes)
  }
  get defaultInsuranceType(): string | null {
    return this.getDefaultValue(this.insuranceTypes)
  }
}
